import React from "react";

const ROWS = [["cost", "Cost (lines)"], ["allowances", "Allowances"], ["overhead", "Overhead"], ["markup", "Profit / markup"],
  ["contingency", "Contingency"], ["tax", "Tax"], ["total", "Total"]];

// Server-calculated totals only (POST /estimating/estimates/:id/calc or the saved estimate). Never computed here.
export default function TotalsPanel({ calc, stale }) {
  return (
    <section className="border border-erf-borderCream rounded bg-white p-4" aria-labelledby="totals-title" data-testid="totals-panel">
      <h2 id="totals-title" className="font-display font-semibold mb-2">Totals {stale && <span className="text-xs font-nav text-erf-dark/60" data-testid="totals-stale">(recalculating…)</span>}</h2>
      {!calc ? <p className="text-xs font-mono">Waiting for the server…</p> : (
        <dl className="grid grid-cols-2 gap-x-4 gap-y-1 text-sm">
          {ROWS.map(([k, label]) => (
            <React.Fragment key={k}>
              <dt className={k === "total" ? "font-semibold" : ""}>{label}</dt>
              <dd className={`text-right font-mono ${k === "total" ? "font-semibold" : ""}`} data-testid={`total-${k}`}>${calc.money[k]}</dd>
            </React.Fragment>
          ))}
        </dl>
      )}
      <p className="mt-2 text-xs text-erf-dark/60">Rounded half-up to the cent at each step; contingency applies after markup, tax last.</p>
    </section>
  );
}
